/**
 * Return the day difference between two dates
 * @param date1 Date
 * @param date2 Date
 */
export const getDayDifference = (date1: Date, date2: Date): number => {
  return Math.floor((date1.getTime() - date2.getTime()) / (1000 * 3600 * 24))
}
